<tds-app-shell>
  <header tds-header>
    <!-- Left: App name with icon -->
    <div tds-header-app-name name="ARCHIMED">
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        tds-header-app-logo
      >
        <rect width="32" height="32" rx="6" fill="url(#archimed-gradient)" />
        <path
          d="M8 16L14 10L20 16L26 10"
          stroke="white"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <defs>
          <linearGradient
            id="archimed-gradient"
            x1="0"
            y1="0"
            x2="32"
            y2="32"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stop-color="#4169E1" />
            <stop offset="50%" stop-color="#0066CC" />
            <stop offset="100%" stop-color="#00A3E0" />
          </linearGradient>
        </defs>
      </svg>
    </div>

    <!-- Right: User actions -->
    <tds-header-end>
      <span class="user-name">{{ userName() }}</span>

      <button
        tds-icon-button
        variant="tertiary"
        size="md"
        label="Profile"
        (click)="onProfileClick()"
      >
        <tds-icon name="account_circle"></tds-icon>
      </button>

      <button
        tds-icon-button
        variant="tertiary"
        size="md"
        label="Help"
        (click)="onHelpClick()"
      >
        <tds-icon name="help"></tds-icon>
      </button>

      <button
        tds-icon-button
        variant="tertiary"
        size="md"
        label="Notifications"
        (click)="onNotificationsClick()"
      >
        <tds-icon name="notifications"></tds-icon>
      </button>

      <span class="language">{{ currentLanguage }}</span>
    </tds-header-end>
  </header>

  <!-- Global loading overlay -->
  @if (isLoading()) {
  <lib-loading-spinner [overlay]="true" [size]="80" />
  }

  <!-- Content area -->
  <div class="app-content">
    <app-navigation></app-navigation>
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</tds-app-shell>
